import { Injectable, inject } from "@angular/core";
import { HttpService } from "@app/core/services/http/http.service";
import { TranslocoLoader, Translation } from "@jsverse/transloco";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpService);

  getTranslation(lang: string) {
    return this.http.makeNonUSSICall().removeDefaultEncoding().removeDefaultHeaders().get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
